import { Phone, MessageCircle, Mail } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "@/config/siteConfig";
import { useSiteSettings, getPhones, getWaNumber, telHref } from "@/lib/siteSettings";
import { scrollToId } from "@/lib/scroll";

export const MobileBar = () => {
  const { site } = useSiteSettings();
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-navy border-t border-gold/30 grid grid-cols-3"
      data-testid="mobile-sticky-bar"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={telHref(getPhones(site)[0].number)}
        data-testid="mobile-sticky-bar-call"
        className="flex flex-col items-center justify-center gap-1 py-3 text-white/85 active:bg-white/5"
      >
        <Phone size={18} className="text-gold" />
        <span className="text-[10px] font-bold tracking-[0.16em]">CALL</span>
      </a>
      <a
        href={waLink(DEFAULT_WA_MESSAGE, getWaNumber(site))}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-sticky-bar-whatsapp"
        className="flex flex-col items-center justify-center gap-1 py-3 text-white/85 border-x border-white/10 active:bg-white/5"
      >
        <MessageCircle size={18} className="text-gold" />
        <span className="text-[10px] font-bold tracking-[0.16em]">WHATSAPP</span>
      </a>
      <button
        onClick={() => scrollToId("#enquire")}
        data-testid="mobile-sticky-bar-enquire"
        className="flex flex-col items-center justify-center gap-1 py-3 text-white/85 active:bg-white/5"
      >
        <Mail size={18} className="text-gold" />
        <span className="text-[10px] font-bold tracking-[0.16em]">ENQUIRE</span>
      </button>
    </nav>
  );
};
